import BookingsReportsPage from "PFApp/insights/parts/bookings_reports/bookings_reports_page";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { PermissionRule } from "PFTypes";
import React from "react";

import { TopActionsPanel } from "./top_actions_panel";

export const Reports = (): JSX.Element => {
  // use to disable export and manage reports buttons
  const isPermittedToExport = useIsCurrentUserPermittedTo(PermissionRule.Reporter);

  return (
    <>
      <TopActionsPanel shouldHideActionButtons={!isPermittedToExport} />
      <BookingsReportsPage />
    </>
  );
};
